function addComboNote() {
  document.querySelectorAll('.option-label--selected').forEach(function(el) {
    // Only add if text is exactly "Combo Pack" (case-insensitive)
    if (el.textContent.trim().toLowerCase() === 'combo pack') {
      // Avoid duplicates
      if (!el.nextElementSibling || !el.nextElementSibling.classList.contains('combo-note')) {
        var note = document.createElement('div');
        note.className = 'combo-note';
        note.textContent = 'Note: Combo pack contains 1 nasal spray and 1 mouth spray';
        note.style.fontSize = '14px';
        note.style.color = '#555';
        note.style.marginTop = '6px';
        el.insertAdjacentElement('afterend', note);
      }
    }
  });
}

// Keep checking every 0.5 seconds so it works on page load and when variants change
setInterval(addComboNote, 500);
